<template>
  <div class="management-content">
    <div class="title-box">
      <div class="page-title">{{ $t("Attach_1") }}</div>
      <div class="right-box">
        <!-- 검색 -->
        <a-input-search class="search-input" v-model:value="searchText" :placeholder="$t('Common_Search')"
          @search="onSearch" />
        <div class="page-buttons">
          <a-button class="menu-button" :class="{ disable: btnDisable }"
            @click="() => toggleModal('downloadVisible')">{{
              $t("Common_Download") }}</a-button>
          <SampleDownloadModal v-if="downloadVisible" :visible="downloadVisible"
            :toggleModal="() => toggleModal('downloadVisible')" />

          <a-button class="menu-button" @click="() => toggleModal('uploadVisible')">{{ $t("Common_Enroll") }}</a-button>
          <SampleUploadEditModal v-if="uploadVisible" mode="add" :visible="uploadVisible"
            :toggleModal="() => toggleModal('uploadVisible')" />
        </div>
      </div>
    </div>
    <CommonTable :loading="loading" :data="tableData" :columns="columns" :fetchData="getAttachSample"
      :pagination="pagination" :handleTableChange="handleTableChange" :useSelection="true" :handleSelect="handleSelect"
      target="attachSampleNo" settingType="attachSample" />
  </div>
</template>

<script>
import { onMounted, toRefs, reactive, watch, computed, ref } from "vue";
import { apiUrl } from "@/utils/common";
import { useStore } from "vuex";
import axios from "axios";

import SampleDownloadModal from "@/components/sideComponents/SampleDownloadModal";
import SampleUploadEditModal from "@/components/sideComponents/SampleUploadEditModal";
import CommonTable from "@/components/commonComponents/CommonTable";
import { useI18n } from "vue-i18n";

export default {
  name: "Sample",
  components: {
    SampleDownloadModal,
    SampleUploadEditModal,
    CommonTable,
  },
  setup() {
    const store = useStore();
    const { t } = useI18n();
    const attachSampleState = computed(
      () => store.getters["attachSample/STATE"]
    );

    const state = reactive({
      tableData: [],
      loading: false,
      downloadVisible: false,
      uploadVisible: false,
      searchText: '',
      pagination: {},
      pagesize: 12,
      currentPage: 1,
    });

    const btnDisable = computed(() => !attachSampleState.value.selectedNo);

    const columns = [
      {
        align: "center",
        width: 30,
        slots: { customRender: "radiobutton" },
      },
      {
        align: "center",
        width: 50,
        slots: { title: "settingTitle", customRender: "settingIcon" },
      },
      {
        title: "No",
        dataIndex: "attachSampleNo",
        align: "center",
        width: 60,
        ellipsis: true,
      },
      {
        title: t("Attach_File3"),
        dataIndex: "attachSampleExt",
        align: "center",
        width: 80,
        ellipsis: true,
      },
      {
        title: t("Common_Content"),
        dataIndex: "attachSampleContent",
        align: "center",
        width: 400,
        ellipsis: true,
      },
      {
        title: t("Attach_File4"),
        dataIndex: "userName",
        align: "center",
        width: 150,
        ellipsis: true,
      },
      {
        title: t("Common_RegDate"),
        dataIndex: "regEpoch",
        align: "center",
        width: 150,
        slots: { customRender: "dateTime" },
      },
    ];

    onMounted(() => {
      getAttachSample();
    });

    watch(
      () => attachSampleState.value.needReload,
      (currentValue, prevValue) => {
        // 샘플 등록/수정/삭제 후 테이블 목록 재조회
        if (currentValue) getAttachSample();
      }
    );

    watch(
      () => state.currentPage,
      () => {
        getAttachSample();
      }
    );

    const toggleModal = (name) => {
      state[name] = !state[name];
    };

    // 라디오 버튼 선택 이벤트
    const handleSelect = (value) => {
      store.dispatch("attachSample/SELECT_ATTACH_SAMPLE", value);
    };

    const onSearch = (value) => {
      // 1페이지로 초기화
      state.currentPage = 1;
      getAttachSample();
    };

    const getAttachSample = async () => {
      state.loading = true;
      try {
        const filter = {};
        if (state.searchText) filter.searchAll = state.searchText;

        const params = {
          filter,
          sort: {},
          offset: state.pagesize * (state.currentPage - 1),
          limit: state.pagesize,
        };

        const response = await axios.get(apiUrl + "AttachSample", { params });
        if (response && !response.data.error) {
          store.dispatch("attachSample/GET_ATTACH_SAMPLE", response);
          state.tableData = response.data.list;
          state.pagination.current = state.currentPage;
          state.pagination.pageSize = state.pagesize;
          state.pagination.total = attachSampleState.value.totalCount;
        }
      } catch (error) {
        console.log("get attach sample error", error);
      }
      state.loading = false;
    };

    // 페이지 변경 이벤트
    const handleTableChange = (pagination, filters, sorter) => {
      state.currentPage = pagination.current;
    };

    return {
      ...toRefs(state),
      btnDisable,
      handleTableChange,
      columns,
      toggleModal,
      handleSelect,
      getAttachSample,
      onSearch,
    };
  },
};
</script>

<style></style>